import React, { useEffect, useState } from "react";
import { Col, Form, Input, Modal, theme , Row , Divider} from "antd";
import { POST, PATCH } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import ErrorMessages from "../../../common/ErrorMessages";

export default function SellChemicalModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages , setErrorMessages] = useState(null);

  useEffect(() => {
    if (target) {
      form.setFieldsValue(target)
    } else {
      form.resetFields();
    }
  }, [open]);

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();


  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();

      if (target?.id) {
        await PATCH(`${URL_SETTING.SELLER_CHEMICAL}${target.id}/`, data);
      } else {
        await POST(URL_SETTING.SELLER_CHEMICAL, data );
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขผู้ขายสารเคมี" : "เพิ่มผู้ขายสารเคมี"}
      width={550}
      onOk={handleOK}
      destroyOnClose
      centered
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}    
    >
      
      <ErrorMessages message={errorMessages} />
      <Form form={form} layout="vertical" style={{ padding: "10px 20px" }}>
        <Row gutter={10}>

          <Col span={8}>
            <Form.Item
              label="รหัส (Code)"
              name="code"
              rules={[{ required: true, message: "กรุณากรอก Code" }]}
            >
              <Input placeholder="รหัส (Code)"/>
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item
              label="ชื่อผู้ขาย"
              name="name"
              rules={[{ required: true, message: "กรุณากรอกชื่อลูกค้า" }]}
            >
              <Input placeholder="ชื่อลูกค้า"/>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="ที่อยู่"
              name="address"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Input.TextArea autoSize={{ minRows: 2, maxRows: 4 }} placeholder="ที่อยู่"/>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="หมายเหตุ"
              name="note"
              rules={[{ required: false }]}
            >
              <Input.TextArea autoSize={{ minRows: 2, maxRows: 4 }} placeholder="หมายเหตุ"/>
            </Form.Item>
          </Col>

          <Divider>ข้อมูลผู้ติดต่อ</Divider>

          <Col span={16}>
            <Form.Item
              label="ชื่อผู้ติดต่อ"
              name="contact"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <Input placeholder="ชื่อผู้ติดต่อ"/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="เบอร์โทรติดต่อ"
              name="phone"
              rules={[{ require: false }]}
            >
              <Input placeholder="เบอร์โทรติดต่อ"/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
